import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  generateInvoice,
  getOrderSummaryDetails,
  getFinalInvoiceDetails,
} from "../../../functions/invoiceGenerator";
import { getUserInfoFromSession } from "../../../adapters/session/localSessionAdapter";
export function InvoiceList(props) {
  const { estimateData, setListOfGoods, estimateStatus } = props;
  const [toggle, setToggle] = useState(false);
  const handleOrderSummaryPdf = (estimateData, paymentData) => {
    const userSession = getUserInfoFromSession();
    const customerInfo = {
      name: userSession["customerName"],
      email: userSession["email"],
      phone: userSession["phone"],
      alternatePhone:userSession["alternatePhone"]
    };

    const orderDetails = getOrderSummaryDetails(
      estimateData,
      paymentData,
      customerInfo
    );
    const paymentType = paymentData["payment_type"];
    generateInvoice(
      estimateData["estimate_id"],
      orderDetails,
      "order_summary",
      paymentType
    );
  };
  const handleFinalInvoiceBillPdf = (estimateData) => {
    const userSession = getUserInfoFromSession();
    const customerInfo = {
      name: userSession["customerName"],
      email: userSession["email"],
      phone: userSession["phone"],
      alternatePhone:userSession["alternatePhone"]
    };
    const invoiceDetails = getFinalInvoiceDetails(estimateData, customerInfo);
    generateInvoice(
      estimateData["estimate_id"],
      invoiceDetails,
      "final_invoice"
    );
  };
  let balanceVersion = 0;
  const JSX = (
    <Dropdown
      isOpen={toggle}
      toggle={() => {
        setToggle(!toggle);
      }}
      direction={"down"}
      tag={"div"}
      className={`w-100`}
    >
      <DropdownToggle caret className={`w-100`}>
        Invoice
      </DropdownToggle>
      <DropdownMenu>
        {estimateData.successfulPayments.map((paymentData) => {
          if(paymentData.payment_type === "balance") {
            balanceVersion++;
            return (
              <DropdownItem
                className="text-left px-1 pt-1 pb-2 text-capitalize"
                onClick={() => {
                  handleOrderSummaryPdf(estimateData, paymentData);
                }}
              >
                {paymentData.payment_type} Order summary-{balanceVersion}
              </DropdownItem>
            );

          }
          return (
            <DropdownItem
              className="text-left px-1 pt-1 pb-2 text-capitalize"
              onClick={() => {
                handleOrderSummaryPdf(estimateData, paymentData);
              }}
            >
              {paymentData.payment_type} Order summary
            </DropdownItem>
          );
        })}
        {estimateStatus === 6 && (
          <DropdownItem
            className="text-left px-1 pt-1 pb-2  text-capitalize"
            onClick={() => {
              handleFinalInvoiceBillPdf(estimateData);
            }}
          >
            Final Invoice Bill
          </DropdownItem>
        )}
        <DropdownItem
          className="text-left px-1 pt-1 pb-2  text-capitalize"
          onClick={() => {
            setListOfGoods({
              status: true,
              estimateId: estimateData["estimate_id"],
            });
          }}
        >
          List of Goods
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
  return JSX;
}
